import { apiRequest } from '../client';

export async function getPublicComingSoonStatus() {
  return apiRequest('/api/public/system/coming-soon');
}

export async function verifyComingSoonAccessCode(code) {
  const result = await apiRequest('/api/public/system/coming-soon/verify', {
    method: 'POST',
    body: { code },
  });
  if (!result?.ok) {
    throw new Error(result?.error || 'That code did not work.');
  }
  return true;
}

export async function getPublicAppMaintenanceStatus() {
  return apiRequest('/api/public/system/maintenance');
}

export async function getPublicWebsiteMaintenanceStatus() {
  return apiRequest('/api/public/system/website-maintenance');
}

export async function getPublicControlPanelName() {
  const result = await apiRequest('/api/public/system/control-panel');
  return result?.name || 'Neat Schedule Control';
}

export async function getPublicAppVersion() {
  return apiRequest('/api/public/system/version');
}

export async function getPublicAdminGateStatus() {
  return apiRequest('/api/public/system/admin-gate');
}

export async function verifyAdminGateAccessCode(code) {
  const result = await apiRequest('/api/public/system/admin-gate/verify', {
    method: 'POST',
    body: { code },
  });
  if (!result?.ok) {
    throw new Error(result?.error || 'Invalid security code. Access denied.');
  }
  return true;
}
